var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-popover",
    {
      ref: "popover",
      attrs: {
        "popover-class": _vm.classes,
        "open-group": _vm.id,
        open: _vm.showPopover,
        trigger: "manual"
      },
      on: {
        hide: function($event) {
          _vm.showPopover = false
        }
      }
    },
    [
      _c("i", {
        staticClass: "fa fa-ellipsis-v tooltip-target",
        on: {
          mouseenter: function($event) {
            _vm.showPopover = true
          }
        }
      }),
      _vm._v(" "),
      _vm._t("popover", null, { slot: "popover" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }